const MODAL_BODY_MAX_HEIGHT = 'calc(100vh - 200px)'

export { MODAL_BODY_MAX_HEIGHT }
